import Vue from 'vue'
import router from "../router"
// =====================请求拦截器=================================================
Vue.http.interceptors.push(function(request, next) {
    if (request.method === "POST") {
        GLOBAL.showBusy("加载中")
    }
    let timeout
    // 如果某个请求设置了_timeout,那么超过该时间，会终端该（abort）请求,并执行请求设置的钩子函数onTimeout方法，不会执行then方法。
    if (request._timeout) {
        timeout = setTimeout(() => {
            if (request.onTimeout) {
                request.onTimeout(request)
                request.abort()
            }
        }, request._timeout)
    }
    next(function(response) {
        clearTimeout(timeout)
        GLOBAL.hideBusy()
        if(response.body.status){
            if(response.body.status.error==50){
                GLOBAL.setInfo('LoginStatus',false)
                if(router.history.current.meta.requireLogin){
                    let targetUrl = location.href
                    // 初始化inWeixin全局参数
                    GLOBAL.init()
                    if (GLOBAL.inWeixin) {
                        LOGIN.loginWeixin(targetUrl)
                    } else {
                        router.push({
                            path: "/normalLogin",
                            query: {
                                redirect: targetUrl
                            }
                        })
                    }
                }
            }else if(response.body.status.error==500){
                GLOBAL.showBusy("请求失败，请稍后尝试；如果多次失败，请联系萌爪顾问微信号：mengzhuaguwen")
                setTimeout(() => {
                    GLOBAL.hideBusy()
                }, 1000)
            }else if(response.body.status.error==0){
                return response
            }
            else{
                GLOBAL.showBusy("请求失败，请稍后尝试；如果多次失败，请联系萌爪顾问微信号：mengzhuaguwen")
                // setTimeout(() => {
                //     GLOBAL.hideBusy()
                // }, 1000)
            }
        }
    })
})


// WEBPACK FOOTER //
// ./src/lib/httpConfig.js